// getToyCommandData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getResourceUrl from '../resource/getResourceUrl.js';
import { PUBLIC } from '../resource/resourceUrlTypeConstants.js';
import getRemoteConfigData from './getRemoteConfigData.js';
import { PUBLIC_PRODUCT_URL_PATH } from '../RemoteConfigKeys.js';

const DEFAULT_COMMAND_ANIMATION_NAME = 'commend';

/**
 * Select toy command animation data
 * @kind selector
 * @param {Immutable.Map} state - root state (required for cached selector pattern)
 * @param {string} preset - device preset for toy devices
 * @param {string} dataKey - data key to retrieve
 * @return {any} The selected toy command data.
 */
const getToyCommandData = createCachedSelector(
  (state, preset) => preset,
  (state, preset, dataKey) => dataKey,
  state => getRemoteConfigData(state, PUBLIC_PRODUCT_URL_PATH),
  (preset, dataKey, publicProductUrlPath) => {
    if (dataKey === 'image' || dataKey === 'largeImage') {
      const suffix = dataKey === 'largeImage' ? '_large' : '';
      const animationPresetName = preset || DEFAULT_COMMAND_ANIMATION_NAME;

      const result = getResourceUrl({
        path: publicProductUrlPath,
        endpoint: `/${animationPresetName}${suffix}.png?format=SOURCE`,
        resourceType: PUBLIC,
      }).href;

      return result instanceof Collection ? result.toJS() : result;
    }

    return null;
  }
)((state, preset, dataKey) => `${preset}:${dataKey}`);

export default getToyCommandData;
